import React, { useEffect, useState, useRef } from "react";
import { Row, Col, Form } from "react-bootstrap";
import { apiHelper } from "../lib/ApiHelper";
import { Typeahead } from 'react-bootstrap-typeahead';
import "./Landing.css";
import * as moment from 'moment';
import { AgGridReact } from "@ag-grid-community/react";
import "@ag-grid-community/styles/ag-grid.css";
import "@ag-grid-community/styles/ag-theme-quartz.css";
import "@ag-grid-community/styles/ag-theme-balham.css";
import { ClientSideRowModelModule } from "@ag-grid-community/client-side-row-model";
import { RangeSelectionModule } from "@ag-grid-enterprise/range-selection";
import { ModuleRegistry } from "@ag-grid-community/core";
ModuleRegistry.registerModules([
    ClientSideRowModelModule,
    RangeSelectionModule,
]);
import { LicenseManager } from "@ag-grid-enterprise/core";
import { useLocation} from "react-router-dom";

LicenseManager.setLicenseKey("Using_this_{AG_Grid}_Enterprise_key_{AG-058820}_in_excess_of_the_licence_granted_is_not_permitted___Please_report_misuse_to_legal@ag-grid.com___For_help_with_changing_this_key_please_contact_info@ag-grid.com___{Penguin_Random_House_LLC}_is_granted_a_{Single_Application}_Developer_License_for_the_application_{InventoryHub}_only_for_{1}_Front-End_JavaScript_developer___All_Front-End_JavaScript_developers_working_on_{InventoryHub}_need_to_be_licensed___{InventoryHub}_has_not_been_granted_a_Deployment_License_Add-on___This_key_works_with_{AG_Grid}_Enterprise_versions_released_before_{4_April_2025}____[v3]_[01]_MTc0MzcyMTIwMDAwMA==a87b1efc2ee2da35884b94c846d80314");
export default function SearchPopup(props) {
    const [singleSelections, setSingleSelections] = useState([]);
    const [options, setOptions] = useState([]);
    const [andOr, setAndOr] = useState(false);
    const [rowData, setRowData] = useState([]);
    const [columnDefs, setColumnDefs] = useState([]);
    const [totalCount, setTotalCount] = useState(0);
    const [selectedISBN, setSelectedISBN] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const [cancelSearch, setCancelSearch] = useState(false);
    const location = useLocation();
    const gridOptions = {
        defaultColDef: {
            resizable: true,
            sortable: true
        },
        pagination: true,
        paginationPageSize: 1000,
        animateRows: true,
        accentedSort: true,
        suppressRowClickSelection: true,
        suppressDragLeaveHidesColumns: true, // ✅ stops column from being dragged away (out of the grid)
        suppressColumnMoveAnimation: false,  // optional: shows animation when interchanging
        rowSelection: 'multiple',
        alwaysShowHorizontalScroll: true,
        onSelectionChanged: onSelectionChanged,
                onGridReady: (event) => event.api.sizeColumnsToFit()
    }
    const gridApi = useRef(null);
    const leftAlign = ["Prodkey", "Isbn"];
    const rightAlign = ["US Cover Price", "Amazon Asin", "Can Cover Price", "Amz With Tax Price", "Can Agency Price", "US Agency Price", "Weight"];
    const centreAlign = ["Digital Only", "Early On Sale", "Drop In Title", "Glb", "Is Network Only", "Movie Tie In", "Original", "Is Prepack", "Pos Baker Spdstk", "Active Status Code"];
  
    const onclose = () => {
        setCancelSearch(true);
        props.onClose();

    }

    const selectISBNClick =  async() => {
        // apiHelper.checkForDup(selectedISBN, props.upn, props.isbnData, props.setIsbnData,false);
       
        setCancelSearch(true);
        if (location?.pathname != "/overview") {
            const deletePRevData = false;
           await  apiHelper.inventoryPostCall("setTitleList", {
                 isbnList: selectedISBN,
                upn: props.upn,
                flag: deletePRevData
            })
            window.location.href = "/overview";
        } else {
            const prepend = true;
            const formOverview = false;
            const updateSetTitle = true;
           await apiHelper.ISBNCheck(selectedISBN, props.upn, props.setIsbnData, props.isbnData, prepend, formOverview, updateSetTitle);
        }
        props.onClose();
    }

    const onGridReady = async (params) => {
        gridApi.current = params.api;
        gridApi.current.sizeColumnsToFit();

    };

    function onSelectionChanged() {
        const selectedRows = gridApi.current.getSelectedRows();
        const isbnList = selectedRows.map(i => i.ISBN);
        setSelectedISBN(isbnList);
    }

    function onGoClick() {
        try {
            if (isLoading) {
                setCancelSearch(true);
                setTimeout(() => firstQueryCall(), 2000);
            }
            firstQueryCall();
        } catch (error) {
            console.error(error);
        }
    }

    function onOptionSelect(e) {
        if (e && e.length > 0) {
            setSingleSelections(e[0]);
        }
    }

    async function firstQueryCall() {
        gridApi.current.setRowData([]);
        let payload = {
            upn: props.upn,
            searchMode: andOr ? "and" : "or",
            Keyword: singleSelections,
            PageSize: 1000,
            PageNumber: 1,
            ContinuePaging: true
        };
        if (!cancelSearch)
        queryControllerCall(payload);
    }

    async function queryControllerCall(payload) {
        try {
            const doCancel = cancelSearch;
            if (payload.PageNumber == 1) {
                setRowData([]);
                setIsLoading(true);
                setCancelSearch(false);
            }
            let result = await apiHelper.azureSearch(payload);
            if (doCancel) {
                result.parameter.continuePaging = false;
            }
            if (result) {
                setRowData((prevData) => [...prevData, ...result.data]);
                setTotalCount(result.totalCount);
                if (!doCancel && result.parameter.continuePaging) {
                    result.parameter.pageNumber++;
                    await queryControllerCall(result.parameter);
                } else {
                    setIsLoading(false);
                    setCancelSearch(false);
                }
            }
        } catch (error) {
            console.error("azure search failed ", error);
            setIsLoading(false);
        }
    }
    function handleRadio(e) {
        setAndOr(e.target.value === "true");
    }

    async function onKeyInput(txt, e) {
        try {
            setSingleSelections(txt);
            const data = await apiHelper.azureSearchSuggest(txt);
            if (data && data.length > 0) {
                setOptions(data);
            }
        } catch (error) {
            console.error("azure suggestion failed ", error);
        }
    }
    
    useEffect(() => {        
        loadColumnDef();
    }, []);

    const loadColumnDef = async ()=>{
        try {
            const data = await apiHelper.getColumnDef();      

            const gridColumnInformation = data.map(item => {
                if (leftAlign.includes(item.headerName)) {
                    item.cellClass = "cell-text-left";
                    item.headerClass = "HeaderClassSource header-text-left";
                } else if (rightAlign.includes(item.headerName)) {
                    item.cellClass = "cell-text-right";
                    item.headerClass = "HeaderClassSource header-text-right";
                } else if (centreAlign.includes(item.headerName)) {
                    item.headerClass = "HeaderClassSource header-text-centre";
                } else {
                    // Default based on datatype
                    if (item.datatype === "string") {
                        item.cellClass = "cell-text-left";
                        item.headerClass = "HeaderClassSource header-text-left";
                    } else {
                        item.cellClass = "cell-text-right";
                        item.headerClass = "HeaderClassSource header-text-right";
                    }
                }
                
                if (item.datatype === "datetime") {
                    item.valueFormatter = function (params) {
                        if (!params.value)
                            return null;
                        return moment(params.value).format('MM/DD/yyyy');
                    }
                };
                item.width = 100;
                return item;
            });
            const checkBoxColumn = { headerName: '', enable: false, width: 40, checkboxSelection: true, headerCheckboxSelection: true, multipleSelection:true,headerCheckboxSelectionFilteredOnly: true, filter: false, suppressMenu: true, headerClass: "HeaderClassSource1",cellClass:"checkboxcell"};
            gridColumnInformation.splice(0, 0, checkBoxColumn);
            setColumnDefs(gridColumnInformation);
        } catch (error) {
            console.error("get Collumndef failed ", error);
        }
    }

    return (

        <div className="popup-overlay container-fluid">
            <div className="srch-popup" style={{ overflowY: "hidden" }}><button className="popup-close-btn" onClick={onclose}></button>
                <div className="search-popup-content"  >
                    <div className="search-input-nav">
                        <Form.Group>
                            <Form.Label><div className="search-title-box">
                                <span className="search-title mr-1">SEARCH ALL FIELDS </span><i className="fa fa-question-circle-o  question-mk" aria-hidden="true"></i>
                                <div className="radio-button-search">
                                    <input id='or' type="radio" name="or"
                                        value={false} checked={andOr == false} onChange={handleRadio}
                                    /> Or
                                    <input id='and' type="radio" name="and"
                                        value={true} checked={andOr == true} onChange={handleRadio}
                                    /> And</div>
                            </div></Form.Label><br />
                            <div className="search-input-nav">
                                <Typeahead
                                    id="basic-typeahead-single"
                                    labelKey="name"
                                    onChange={onOptionSelect}
                                    onInputChange={onKeyInput}
                                    options={options}
                                    placeholder="Type to search..."
                                />
                                <button className="go-search-btn ml-5" onClick={onGoClick} >Go</button>
                            </div>
                        </Form.Group>
                    </div>
                    <div className="mt-4">
                        <Row>
                            <Col className="align-bot font-black" md={1}>Count: {totalCount}  </Col>
                            <Col className="align-bot font-black" md={1}> {isLoading && 'Loading...'}</Col>
                            <Col><button className="ISBNSubmit" disabled={selectedISBN.length < 1} onClick={selectISBNClick}>Select ISBN</button> </Col>
                        </Row>
                    </div>
                    <div className="ag-theme-balham" style={{ height:"70vh",width:"100%"}}>
                        <AgGridReact
                            rowData={rowData}
                            columnDefs={columnDefs}
                            rowSelection="multiple"
                            gridOptions={gridOptions}
                            onGridReady={onGridReady}
                        />
                    </div>
                </div>
            </div>
        </div>
    )

}